export default __webpack_public_path__ + "static/media/sunny.cfc6d0bb.gif";